import React from 'react';

const ErrorMsg = (props: any) => (
    <div className="invalid-msg">{props.errorText}</div>
);

export default ErrorMsg;
